/**
 * FILE: apps/hub/src/hooks/useAuth.ts
 * PURPOSE: Custom React hook.
 * AGENT_CONTEXT: Reusable logic. Follow Rules of Hooks. No side effects in render.
 * LAST_REVIEWED: 2026-05-07
 */

import { useContext } from 'react'
import { AuthContext } from '@/hooks/auth-context'

export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within AuthProvider')
  return ctx
}
